import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { apiCall } from '../../services';

const ENDPOINT = `${APIConfiguration.repairer}iriscode/locales`;

interface IrisCodeReturnValuesItem {
  cultureCode: string;
  key: string;
  label: string;
}

interface IrisCodeReturnValues {
  IrisConditionCode: IrisCodeReturnValuesItem[];
  IrisSymptomCode: IrisCodeReturnValuesItem[];
  IrisSectionCode: IrisCodeReturnValuesItem[];
  IrisDefectCode: IrisCodeReturnValuesItem[];
  IrisRepairCode: IrisCodeReturnValuesItem[];
  IrisExtendedConditionCode: IrisCodeReturnValuesItem[];
}

export const getIrisCode = async (): Promise<
  BackResponse<IrisCodeReturnValues> | BackResponseFailure
> => {
  try {
    const response = await apiCall<BackResponse<IrisCodeReturnValues>>(
      ENDPOINT,
      {
        method: SUPPORTED_METHODS.GET,
      },
    );

    return response;
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};
